/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ClaimsSchema } from './ClaimsSchema';

export const SchemaImportDataRequest: core.serialization.ObjectSchema<
    serializers.SchemaImportDataRequest.Raw,
    Truvity.SchemaImportDataRequest
> = core.serialization.object({
    schema: ClaimsSchema,
    slug: core.serialization.string().optional(),
    version: core.serialization.number().optional(),
});

export declare namespace SchemaImportDataRequest {
    export interface Raw {
        schema: ClaimsSchema.Raw;
        slug?: string | null;
        version?: number | null;
    }
}
